import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import './checkbox.css';
import Checkbox from './checkbox.js';
import { htmlDecode, slugify } from '../helpers.js';

var CheckboxGroup = function (_Component) {
	_inherits(CheckboxGroup, _Component);

	function CheckboxGroup() {
		_classCallCheck(this, CheckboxGroup);

		return _possibleConstructorReturn(this, (CheckboxGroup.__proto__ || Object.getPrototypeOf(CheckboxGroup)).apply(this, arguments));
	}

	_createClass(CheckboxGroup, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    options = _props.options,
			    title = _props.title,
			    itemAction = _props.itemAction,
			    shopify_product_title = _props.shopify_product_title,
			    wkSelectedOptions = _props.wkSelectedOptions,
			    step_index = _props.step_index,
			    show_quantity = _props.show_quantity,
			    updateQuantity = _props.updateQuantity;

			var name = slugify(title + ' ' + step_index);
			var printed_title = title === "Title" ? null : title;
			return React.createElement(
				'div',
				{ className: 'CheckboxGroup' },
				React.createElement(
					'p',
					{ className: 'CheckboxGroup-title' },
					printed_title
				),
				options.map(function (option, index) {
					var checked = void 0;
					var id = slugify(option + ' ' + step_index);
					if (wkSelectedOptions) {
						var this_selection = wkSelectedOptions.filter(function (s_option) {
							return htmlDecode(s_option.value.trim()) == option;
						})[0];

						checked = this_selection ? htmlDecode(this_selection.value.trim()) == option : false;
					}
					return React.createElement(
						'div',
						null,
						React.createElement(Checkbox, {
							key: 'checkbox-' + index,
							id: id,
							name: name,
							label: title, value: option,
							itemAction: itemAction,
							checked: checked,
							show_quantity: show_quantity,
							shopify_product_title: shopify_product_title,
							updateQuantity: updateQuantity })
					);
				})
			);
		}
	}]);

	return CheckboxGroup;
}(Component);

export default CheckboxGroup;